// extracted by mini-css-extract-plugin
export default {"actions":"cubGluuULFUs4gru","cell":"OGDYiMJvER0Cdn7o","clickable":"oIpP0HCgJ48AjIlL","row":"M3WevfPOBNo6VMd_","category":"wLEfVAhAwwbmPBsb","name":"YQJdazPXqFosYOD0"};